import React, { useState } from 'react';
import './V1PipelineFilterBar.css';

/**
 * On-screen CNC pipeline filter funnel — shows how panel names become BUY fills.
 */
export default function V1PipelineFilterBar({ filter = null, pipeline = null }) {
  const [open, setOpen] = useState(false);
  if (!filter) return null;

  const gates = filter.gates || [];
  const candle = filter.candle;
  const queueNext = filter.queueNext || [];

  return (
    <section className={`v1-pipe-filter card${open ? '' : ' is-collapsed'}`} aria-label="CNC pipeline filters">
      <button
        type="button"
        className="v1-pipe-filter-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <h4>CNC PIPELINE FILTERS</h4>
        <span>
          {filter.panelUp ?? 0} panel → queue {filter.queueSize ?? 0}
          {' · '}
          {filter.slotsFree ?? 0} slot(s) free
          {' · '}
          1 BUY / {filter.fillIntervalSec ?? 60}s
          <span className="v1-pipe-filter-chevron" aria-hidden>{open ? ' ▾' : ' ▸'}</span>
        </span>
      </button>
      {open && (
        <>
          <p className="v1-pipe-filter-mode">
            Mode: <strong>{filter.confirmMode || 'fee-aware-momentum'}</strong>
            {' · '}
            Target +₹{Number(filter.buyTargetRs || 1).toFixed(2)}/sh
            {' · '}
            Min net ₹{Number(filter.minNetRs || 0).toFixed(0)}
            {candle?.niftyWeak ? ' · Nifty weak — RS leaders only' : ''}
          </p>
          <ol className="v1-pipe-filter-gates">
            {gates.map((g) => (
              <li key={g.id} className="v1-pipe-filter-gate">
                <span className="v1-pipe-filter-gate-label">{g.label}</span>
                <span className="v1-pipe-filter-gate-stat">
                  {g.pass != null && g.pass !== undefined ? (
                    <strong className="pass">{g.pass} pass</strong>
                  ) : null}
                  {g.drop != null && g.drop > 0 ? (
                    <span className="drop"> · {g.drop} dropped</span>
                  ) : null}
                </span>
                {g.note ? <small>{g.note}</small> : null}
              </li>
            ))}
          </ol>
          {queueNext.length > 0 && (
            <p className="v1-pipe-filter-queue">
              <span>Fill queue next:</span>
              {queueNext.map((q) => (
                <span key={q.stock} className="v1-pipe-filter-chip">
                  {q.stock}
                  {q.wholeMarket ? ' · WM' : ''}
                  {q.einstein != null ? ` · E${Math.round(q.einstein)}` : ''}
                </span>
              ))}
            </p>
          )}
          {pipeline?.strategyNote && (
            <p className="v1-pipe-filter-note">{pipeline.strategyNote}</p>
          )}
        </>
      )}
    </section>
  );
}
